import { render, staticRenderFns } from "./AccessoriesNicheIcon.vue?vue&type=template&id=27c41b00&scoped=true"
import script from "./AccessoriesNicheIcon.vue?vue&type=script&lang=js"
export * from "./AccessoriesNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c41b00",
  null
  
)

export default component.exports